import React from 'react';
import NotificationComponent from '../components/NotificationComponent';

function Main({
  show = false,
  onClose,
  title,
  message,
  type = 'warning',
  showConfirmButton = true,
  confirmButtonText,
  onConfirm,
  autoClose = false,
  autoCloseDelay = 5000
}) {
  return (
    <NotificationComponent
      isOpen={show}
      onClose={onClose}
      title={title}
      message={message}
      type={type}
      showConfirmButton={showConfirmButton}
      confirmButtonText={confirmButtonText}
      onConfirm={onConfirm}
      autoClose={autoClose}
      autoCloseDelay={autoCloseDelay}
    />
  );
}

export default Main;
